import { addresses, availabilityCheckPoints } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

// AvailabilityCheckPoint schemas
export const selectAvailabilityCheckPointSchema = createSelectSchema(
  availabilityCheckPoints,
)

export const insertAvailabilityCheckPointSchema = createInsertSchema(
  availabilityCheckPoints,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
  addressId: true,
})

export const updateAvailabilityCheckPointSchema =
  insertAvailabilityCheckPointSchema.partial()

// Address schemas for internal use (not exported to avoid duplication)
const insertAddressSchemaLocal = createInsertSchema(addresses).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

// AvailabilityCheckPoint with address relation
export const selectAvailabilityCheckPointWithAddressSchema =
  selectAvailabilityCheckPointSchema.extend({
    address: z.object({
      id: z.number(),
      street: z.string(),
      city: z.string(),
      postalCode: z.string().nullable(),
      country: z.string().nullable(),
      latitude: z.string().nullable(),
      longitude: z.string().nullable(),
    }),
  })

// Create schema with address
export const createAvailabilityCheckPointWithAddressSchema = z.object({
  address: insertAddressSchemaLocal,
  description: z.string().optional(),
})

// Type exports
export type AvailabilityCheckPoint = z.infer<
  typeof selectAvailabilityCheckPointSchema
>
export type CreateAvailabilityCheckPoint = z.infer<
  typeof insertAvailabilityCheckPointSchema
>
export type UpdateAvailabilityCheckPoint = z.infer<
  typeof updateAvailabilityCheckPointSchema
>
export type AvailabilityCheckPointWithAddress = z.infer<
  typeof selectAvailabilityCheckPointWithAddressSchema
>
export type CreateAvailabilityCheckPointWithAddress = z.infer<
  typeof createAvailabilityCheckPointWithAddressSchema
>

// Time slot summary types for UI
export type TimeSlotSummary = {
  addressId: number
  nextAvailable: string | null // ISO datetime
  todayCount: number
  tomorrowCount: number
  afterCount: number
  totalSlots: number
  slots: Array<{
    startTime: string // ISO datetime
    endTime: string // ISO datetime
    userId: number
    drivingMinutes: number
  }>
}
